module.exports = __webpack_public_path__ + "img/roundupapp_logo.b7e30a9c.png";